module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-Bold-e6a0b2bd7478647a18ff6bb170209095.woff";